var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatatableViewHover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.05882C1 8.05882 4.63636 1 11 1C17.3636 1 21 8.05882 21 8.05882C21 8.05882 17.3636 15.1176 11 15.1176C4.63636 15.1176 1 8.05882 1 8.05882Z",
    stroke: "#292929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10.7059C12.5062 10.7059 13.7273 9.52075 13.7273 8.05882C13.7273 6.59689 12.5062 5.41176 11 5.41176C9.49377 5.41176 8.27273 6.59689 8.27273 8.05882C8.27273 9.52075 9.49377 10.7059 11 10.7059Z",
    stroke: "#292929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatatableViewHover);
export default __webpack_public_path__ + "static/media/datatable-view-hover.68214f9321453168e684e747e2c172b8.svg";
export { ForwardRef as ReactComponent };